<script>
import VTabsBar from 'vuetify/lib/components/VTabs/VTabsBar'

export default {
  name: 'ETabsBar',
  extends: VTabsBar,

  render(h) {
    return h('div', { staticClass: 'e-tabs-bar' }, this.$slots.default)
  },
}
</script>
